import React, { FunctionComponent } from 'react';

export const HiddenField: FunctionComponent = (props) => {
  return <input type={'hidden'} {...props} />;
};
